import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=78048a2c&scoped=true&"
import script from "./Errors.vue?vue&type=script&lang=js&"
export * from "./Errors.vue?vue&type=script&lang=js&"
import style0 from "./Errors.vue?vue&type=style&index=0&id=78048a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78048a2c",
  null
  
)

export default component.exports